import React, { useEffect, useState } from "react"
import sendRequest from "@ecom/ui/utils/sendRequest"
import getSearchParam from "@ecom/ui/utils/getSearchParam"
import { urlDataConfig, urlDataWithCodeConfig } from "./urlDataConfig"
import { HALVA_API_BASE_URL } from "../../../helpers/api"

export default function GetFriendName() {
  const [friend, setFriendName] = useState("Друг")
  const [urlName, setUrlName] = useState(false)
  const clientId = getSearchParam("code")

  useEffect(() => {
    if (
      urlDataConfig("bg-Petropavlovsk-Kamchatsky") ||
      urlDataConfig("bg-Vladivostok-1") ||
      urlDataWithCodeConfig("5968589764")
    ) {
      setUrlName(true)
    }
  }, [urlName])

  useEffect(() => {
    if (clientId === 324595596) {
      setFriendName("Woman_halva.club")
    } else {
      sendRequest(`${HALVA_API_BASE_URL}/v1/cache/client/name`, {
        variable: clientId,
      })
        .then((res: { status: string; firstName: string }) => {
          if (res.status === "success") {
            let { firstName } = res
            firstName = firstName[0].toUpperCase() + firstName.slice(1)
            setFriendName(firstName)
          } else {
            throw new Error("Failed to fetch name")
          }
        })
        .catch((e: Error) => {
          console.error(e)
          setFriendName("Друг")
        })
    }
  }, [clientId])

  return (
    <h1>
      {friend} рекомендует <br className="d-md-none" />
      вам оформить карту «Халва»
    </h1>
  )
}
